import React from 'react';
import Missing from './Missing';
import DeviceSelector from './DeviceSelector';
import { isFirefox, isChrome, isIOS } from 'react-device-detect';

export default class Settings extends React.PureComponent {
    
    state = {
        show: false,
        videoinput: [],
        audioinput: [],
    }

    async loadDevices() {
        let { devices } = await window.sdk.videoconf().getDevices();

        this.setState({
            show: true,
            audioinput: devices['audioinput'],
            videoinput: devices['videoinput'],
            audiooutput: devices['audiooutput']
        });
    }

    async componentDidMount() {

        window.sdk.event().on('deviceChange', () => {
            this.loadDevices(); 
        })
        
        this.loadDevices();
        
    }
    
    render() {
        if(!this.state.show)
            return null;
        return (
            <div className="settings">
                <div className="settings__block">
                    <DeviceSelector kind="videoinput" label="Caméra" devices={ this.state.videoinput } />
                </div>

                <div className="settings__block">
                    { ! isFirefox &&
                        <DeviceSelector kind="audiooutput" disableButton={ true } label="Haut-parleurs" devices={this.state.audiooutput} />
                    }
                </div>

                <div className="settings__block">
                    <DeviceSelector kind="audioinput" label="Microphone" devices={ this.state.audioinput } />
                </div>

                { this.props.withMissing &&
                    <Missing />
                }

            </div>
        );
    }
    
}